import React, { useEffect, useState, useRef } from 'react'
//import { useNavigate } from 'react-router-dom'
//import { getApi } from 'service/axios'
import axios from 'axios'
import ALLOW_RIGHT from 'assets/images/map/allow-right.png'
//import SEARCH_ICON from 'assets/images/map/search-icon.png'
//import PIN_OPEN_ICON from 'assets/images/pin-large_open.png' // 운영중 - Station_State: 1
//import PIN_STOP_ICON from 'assets/images/pin-large_stop.png' //중지 - Station_State: 3
//import PIN_READY_ICON from 'assets/images/pin-large_ready.png' //준비중 - Station_State: 5
import MARKER_ICON from 'assets/images/map/marker-icon-black.png'
import NO_IMAGE from 'assets/images/map/no_image.png'

import PIN_ICON_STATION_OPEN from 'assets/images/map/map_marker_station_open.png' //스테이션 운영중 - Station_State: 1
import PIN_ICON_STATION_OPEN_SELECT from 'assets/images/map/map_marker_station_open_select.png' //선택된 스테이션 운영중 - Station_State: 1
import PIN_ICON_STATION_STOP from 'assets/images/map/map_marker_station_stop.png' //스테이션 중지 - Station_State: 3
import PIN_ICON_STATION_STOP_SELECT from 'assets/images/map/map_marker_station_stop_select.png' //스테이션 중지 - Station_State: 3
import PIN_ICON_STATION_READY from 'assets/images/map/map_marker_station_ready.png' //스테이션 준비중 - Station_State: 5
import PIN_ICON_STATION_READY_SELECT from 'assets/images/map/map_marker_station_ready_select.png' //선택된 스테이션 준비중 - Station_State: 5

import PIN_ICON_SERVICE_OPEN from 'assets/images/map/map_marker_service_open.png' //서비스점 운영중
import PIN_ICON_SERVICE_OPEN_SELECT from 'assets/images/map/map_marker_service_open_select.png' //선택된 서비스점 운영중

import PIN_ICON_MAINTENANCE from 'assets/images/map/map_marker_maintenance.png' //서비스점 점검중
import PIN_ICON_MAINTENANCE_SELECT from 'assets/images/map/map_marker_maintenance_select.png' //선택된 서비스점 점검중

import PIN_ICON_SERVICE_OPEN_PURPLE from 'assets/images/map/map_marker_service_open_purple.png' //서비스점 판매가능점
import PIN_ICON_SERVICE_OPEN_PURPLE_SELECT from 'assets/images/map/map_marker_service_open_select_purple.png' //선택된 서비스점 판매가능점

//import { MAP_API_URL, RESULT_CODE, ROW_SIZE } from 'service/ServiceUtils'
//import { URL } from 'utils/Utils'
import { isEmpty } from 'utils/UtilsFunction'
import './Map.scss'
import { URL } from 'utils/Utils'

const { kakao } = window

/**
 * @file 고객지원 고스테이션 지도 화면
 */
function Map({ initSearchType, isNewPage }) {
    const [map, setMap] = useState(null)
    const [selectSearchType, setSearchType] = useState(initSearchType) //조회 유형 (01 : 대리점, 03: 서비스점, 05: 스테이션)
    const [data, setData] = useState([]) //서버에서 가져온 data
    const [sidoData, setSidoData] = useState([]) //서버에서 가져온 시도 data
    const [gugunData, setGugunData] = useState([]) //서버에서 가져온 구군 data
    const [selectSido, setSelectSido] = useState({}) //선택된 시도
    const [selectGugun, setSelectGugun] = useState({}) //선택된 구군
    const [isSelectSido, setIsSelectSido] = useState(false) //시도 선택하여 select box 표시 여부
    const [isSelectGugun, setIsSelectGugun] = useState(false) //구군 선택하여 select box 표시 여부
    const [selectMarkerInfo, setSelectMarkerInfo] = useState({}) //마커 선택 해서 info box data
    const [markersItems, setMarkersItems] = useState(null) //마커찍은 data
    const [selMarker, setSelMarker] = useState(null)
    const [sidoboxPosition, setSidoboxPosition] = useState({
        X: 0,
        Y: 0,
    })
    const [gugunboxPosition, setGugunboxPosition] = useState({
        X: 0,
        Y: 0,
    })
    let sidoSelectBoxRef = useRef(null)
    let localInfoSelectWrapper = useRef(null)
    let sidoTextRef = useRef(null)
    let gugunTextRef = useRef(null)

    useEffect(() => {
        if (isEmpty(kakao) || isEmpty(kakao.maps)) {
            return
        }
        setUpMap()

        //시도 리스트 호출 api
        axios
            .get(`${process.env.REACT_APP_BASE_URL}/v1/common/district/info`, {
                params: {},
                headers: {
                    'gen-api-key': 'genstation_weIOLf2ghuRDb2dtQ1dsWGVu==',
                },
            })
            .then(response => {
                if (response?.data?.code === '00') {
                    //console.log('response?.data? 시도 : ', response?.data?.data)
                    setSidoData(response?.data?.data)
                    if (response?.data?.data.length > 0) setSelectSido(response?.data?.data[0])

                    //스테이션 리스트 호출 api
                    axios
                        .get(`${process.env.REACT_APP_BASE_URL}/v1/map/station/list`, {
                            params: { search_type: selectSearchType },
                            headers: {
                                'gen-api-key': 'genstation_weIOLf2ghuRDb2dtQ1dsWGVu==',
                            },
                        })
                        .then(response => {
                            if (response?.data?.code === '00') {
                                //console.log('response?.data? 스테이션 : ', response?.data?.data)
                                setData(response?.data?.data)
                            } else {
                                setTimeout(function () {
                                    alert(response?.data?.message)
                                }, 500)
                            }
                        })
                        .catch(error => {
                            if (error && error.response && error.response.status) {
                                setTimeout(function () {
                                    alert(`${error.response.status} error`)
                                }, 500)
                            }
                        })
                } else {
                    setTimeout(function () {
                        alert(response?.data?.message)
                    }, 500)
                }
            })
            .catch(error => {
                if (error && error.response && error.response.status) {
                    setTimeout(function () {
                        alert(`${error.response.status} error`)
                    }, 500)
                }
            })
    }, [])

    useEffect(() => {
        dataReset()
        if (data.length > 0) setMarker()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data])

    useEffect(() => {
        //시도 텍스트 선택 시, select box 떠야함
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSelectSido])

    useEffect(() => {
        //시도 텍스트 선택 시, select box 떠야함
        if (localInfoSelectWrapper.current && isSelectGugun) {
            localInfoSelectWrapper.current.style.marginLeft = gugunTextRef.current.offsetLeft + 'px'
        } else {
            localInfoSelectWrapper.current.style.marginLeft = '0px'
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSelectGugun])

    useEffect(() => {
        dataReset()
        // setIsSelectSido(false)
        setSelectGugun({})
        if (Object.keys(selectSido).length === 0) return
        moveMap()
        if (selectSido?.SIDO === '전체') {
            let _obj = {
                search_type: selectSearchType,
            }

            //스테이션 리스트 호출 api
            axios
                .get(`${process.env.REACT_APP_BASE_URL}/v1/map/station/list`, {
                    params: _obj,
                    headers: {
                        'gen-api-key': 'genstation_weIOLf2ghuRDb2dtQ1dsWGVu==',
                    },
                })
                .then(response => {
                    if (response?.data?.code === '00') {
                        //console.log('response?.data? 스테이션 : ', response?.data?.data)
                        setData(response?.data?.data)
                    } else {
                        setTimeout(function () {
                            alert(response?.data?.message)
                        }, 500)
                    }
                })
                .catch(error => {
                    if (error && error.response && error.response.status) {
                        setTimeout(function () {
                            alert(`${error.response.status} error`)
                        }, 500)
                    }
                })
            return //전체이면 구군 api 호출 x
        }

        //구군 리스트 호출 api
        axios
            .get(`${process.env.REACT_APP_BASE_URL}/v1/common/district/gugun/info`, {
                params: {
                    sido: selectSido?.SIDO,
                    sido_full_name: selectSido?.SIDO_FULL_NAME,
                },
                headers: {
                    'gen-api-key': 'genstation_weIOLf2ghuRDb2dtQ1dsWGVu==',
                },
            })
            .then(response => {
                if (response?.data?.code === '00') {
                    //console.log('response?.data? 구군 : ', response?.data?.data)
                    setGugunData(response?.data?.data)
                    if (response?.data?.data.length > 0) setSelectGugun(response?.data?.data[0])
                } else {
                    setTimeout(function () {
                        alert(response?.data?.message)
                    }, 500)
                }
            })
            .catch(error => {
                if (error && error.response && error.response.status) {
                    setTimeout(function () {
                        alert(`${error.response.status} error`)
                    }, 500)
                }
            })
    }, [selectSido])

    useEffect(() => {
        dataReset()
        setIsSelectGugun(false)
        if (Object.keys(selectSido).length === 0) return
        if (Object.keys(selectGugun).length === 0) return
        moveMap()
        if (selectSido?.SIDO === '전체') return //전체이면 구군 api 호출 x

        let _obj = {
            search_type: selectSearchType,
            sido: selectSido?.SIDO,
        }

        if (selectGugun?.GUGUN !== '전체') _obj.gugun = selectGugun?.GUGUN

        //스테이션 리스트 호출 api
        axios
            .get(`${process.env.REACT_APP_BASE_URL}/v1/map/station/list`, {
                params: _obj,
                headers: {
                    'gen-api-key': 'genstation_weIOLf2ghuRDb2dtQ1dsWGVu==',
                },
            })
            .then(response => {
                if (response?.data?.code === '00') {
                    //console.log('response?.data? 스테이션 : ', response?.data?.data)
                    setData(response?.data?.data)
                } else {
                    setTimeout(function () {
                        alert(response?.data?.message)
                    }, 500)
                }
            })
            .catch(error => {
                if (error && error.response && error.response.status) {
                    setTimeout(function () {
                        alert(`${error.response.status} error`)
                    }, 500)
                }
            })
    }, [selectGugun])

    useEffect(() => {
        const handleClick = e => {
            if (sidoSelectBoxRef.current && !sidoSelectBoxRef.current.contains(e.target)) {
                setIsSelectSido(false)
                setIsSelectGugun(false)
            }
        }
        window.addEventListener('mousedown', handleClick)
        return () => window.removeEventListener('mousedown', handleClick)
    }, [sidoSelectBoxRef])

    useEffect(() => {
        const handleClick = e => {
            if (localInfoSelectWrapper.current && !localInfoSelectWrapper.current.contains(e.target)) {
                setIsSelectSido(false)
                setIsSelectGugun(false)
            }
        }
        window.addEventListener('mousedown', handleClick)
        return () => window.removeEventListener('mousedown', handleClick)
    }, [localInfoSelectWrapper])

    useEffect(() => {
        if (isEmpty(markersItems)) return //markersItems 없을 시
        if (isEmpty(selMarker)) return //selMarker 없을 시

        let defaultImageSize = new kakao.maps.Size(40, 40)
        let clickImageSize = new kakao.maps.Size(50, 55)
        let dafaultIcon,
            clickIcon = 'https://cdn0.iconfinder.com/data/icons/small-n-flat/24/678111-map-marker-128.png'

        //전제 마커중 선택된 마커가 아니면 기본으로 돌리게(전체를 다하는건 비효율적인듯, 추후 다른 로직으로 해야할듯)
        markersItems.map((marker, i) => {
            if (marker !== selMarker) {
                if (selectSearchType === '03') {
                    //서비스점
                    if (data[i]?.Drop_Flag === 'N') {
                        dafaultIcon = PIN_ICON_SERVICE_OPEN
                        clickIcon = PIN_ICON_SERVICE_OPEN_SELECT
                    } else if (data[i]?.Drop_Flag === 'Y') {
                        dafaultIcon = PIN_ICON_SERVICE_OPEN_PURPLE
                        clickIcon = PIN_ICON_SERVICE_OPEN_PURPLE_SELECT
                    }
                } else if (selectSearchType === '05') {
                    //스테이션
                    if (data[i]?.Station_State === '1') {
                        //운영중
                        dafaultIcon = PIN_ICON_STATION_OPEN
                        clickIcon = PIN_ICON_STATION_OPEN_SELECT
                    } else if (data[i]?.Station_State === '3') {
                        //중지
                        dafaultIcon = PIN_ICON_STATION_STOP
                        clickIcon = PIN_ICON_STATION_STOP_SELECT
                    } else if (data[i]?.Station_State === '4') {
                        //점검중
                        dafaultIcon = PIN_ICON_MAINTENANCE
                        clickIcon = PIN_ICON_MAINTENANCE_SELECT
                    } else if (data[i]?.Station_State === '5') {
                        //준비중
                        dafaultIcon = PIN_ICON_STATION_READY
                        clickIcon = PIN_ICON_STATION_READY_SELECT
                    }
                }
                let defaultMarker = new kakao.maps.MarkerImage(dafaultIcon, defaultImageSize)
                marker.setImage(defaultMarker)
            }
        })

        if (selMarker) {
            if (selectSearchType === '03') {
                //서비스점
                if (selectMarkerInfo?.Drop_Flag === 'N') {
                    dafaultIcon = PIN_ICON_SERVICE_OPEN
                    clickIcon = PIN_ICON_SERVICE_OPEN_SELECT
                } else if (selectMarkerInfo?.Drop_Flag === 'Y') {
                    dafaultIcon = PIN_ICON_SERVICE_OPEN_PURPLE
                    clickIcon = PIN_ICON_SERVICE_OPEN_PURPLE_SELECT
                }
            } else if (selectSearchType === '05') {
                //스테이션
                if (selectMarkerInfo?.Station_State === '1') {
                    //운영중
                    dafaultIcon = PIN_ICON_STATION_OPEN
                    clickIcon = PIN_ICON_STATION_OPEN_SELECT
                } else if (selectMarkerInfo?.Station_State === '3') {
                    //중지
                    dafaultIcon = PIN_ICON_STATION_STOP
                    clickIcon = PIN_ICON_STATION_STOP_SELECT
                } else if (selectMarkerInfo?.Station_State === '4') {
                    //점검중
                    dafaultIcon = PIN_ICON_MAINTENANCE
                    clickIcon = PIN_ICON_MAINTENANCE_SELECT
                } else if (selectMarkerInfo?.Station_State === '5') {
                    //준비중
                    dafaultIcon = PIN_ICON_STATION_READY
                    clickIcon = PIN_ICON_STATION_READY_SELECT
                }
            }

            const image = new Image()
            image.src = clickIcon

            image.onload = () => {
                const aspectRatio = image.height / image.width
                const autoHeight = 55 * aspectRatio

                const clickImageSize = new kakao.maps.Size(55, autoHeight)

                const clickedMarker = new kakao.maps.MarkerImage(clickIcon, clickImageSize)
                selMarker.setImage(clickedMarker)
            }
            // let clickedMarker = new kakao.maps.MarkerImage(clickIcon, clickImageSize)
            // selMarker.setImage(clickedMarker)
        }
    }, [selMarker])

    //마커 리셋
    const dataReset = () => {
        setSelectMarkerInfo({}) //선택한 마커 정보 초기화
        //마커 제거
        if (markersItems) {
            markersItems.map(item => {
                item.setMap(null)
            })
            setMarkersItems(null)
        }
    }

    //map setup
    const setUpMap = () => {
        let mapContainer = document.getElementById('service-map') //지도를 담을 영역의 DOM 레퍼런스

        let mapOption = {
            //지도를 생성할 때 필요한 기본 옵션
            center: new kakao.maps.LatLng(36.5, 127.5), // 지도의 중심좌표
            level: 13, // 지도의 확대 레벨
            maxLevel: 13,
        }

        let kakaoMap = new kakao.maps.Map(mapContainer, mapOption) //지도 생성 및 객체 리턴

        let zoomControl = new kakao.maps.ZoomControl()
        kakaoMap.addControl(zoomControl, kakao.maps.ControlPosition.BOTTOMRIGHT)
        setMap(kakaoMap)
    }

    //마커 set
    const setMarker = () => {
        dataReset()

        let ary = []
        //#region  [ 마커 생성 로직 ]
        for (let i = 0; i < data.length; i++) {
            // 마커 이미지의 이미지 크기 입니다
            let imageSize = new kakao.maps.Size(40, 40)
            let clickImageSize = new kakao.maps.Size(55, 55)
            let dafaultIcon,
                clickIcon = 'https://cdn0.iconfinder.com/data/icons/small-n-flat/24/678111-map-marker-128.png'
            let latlng
            let markerImage
            let clickedMarker
            let title

            if (selectSearchType === '03') {
                //서비스점
                latlng = new kakao.maps.LatLng(data[i].Lat, data[i].Lon)
                title = data[i].Name
                if (data[i]?.Drop_Flag === 'N') {
                    dafaultIcon = PIN_ICON_SERVICE_OPEN
                    clickIcon = PIN_ICON_SERVICE_OPEN_SELECT
                } else if (data[i]?.Drop_Flag === 'Y') {
                    dafaultIcon = PIN_ICON_SERVICE_OPEN_PURPLE
                    clickIcon = PIN_ICON_SERVICE_OPEN_PURPLE_SELECT
                }
            } else if (selectSearchType === '05') {
                //스테이션
                latlng = new kakao.maps.LatLng(data[i].Station_Lat, data[i].Station_Lon)
                title = data[i].Station_Name
                if (data[i]?.Station_State === '1') {
                    //운영중
                    dafaultIcon = PIN_ICON_STATION_OPEN
                    clickIcon = PIN_ICON_STATION_OPEN_SELECT
                } else if (data[i]?.Station_State === '3') {
                    //중지
                    dafaultIcon = PIN_ICON_STATION_STOP
                    clickIcon = PIN_ICON_STATION_STOP_SELECT
                } else if (data[i]?.Station_State === '4') {
                    //점검중
                    dafaultIcon = PIN_ICON_MAINTENANCE
                    clickIcon = PIN_ICON_MAINTENANCE_SELECT
                } else if (data[i]?.Station_State === '5') {
                    //준비중
                    dafaultIcon = PIN_ICON_STATION_READY
                    clickIcon = PIN_ICON_STATION_READY_SELECT
                }
            }

            const image = new Image()
            image.src = clickIcon

            image.onload = () => {
                const aspectRatio = image.height / image.width
                const autoHeight = 55 * aspectRatio

                const clickImageSize = new kakao.maps.Size(55, autoHeight)

                const clickedMarker = new kakao.maps.MarkerImage(clickIcon, clickImageSize)
                selMarker.setImage(clickedMarker)
            }
            markerImage = new kakao.maps.MarkerImage(dafaultIcon, imageSize)
            // clickedMarker = new kakao.maps.MarkerImage(clickIcon, clickImageSize)

            // 마커를 생성합니다
            let marker = new kakao.maps.Marker({
                map: map, // 마커를 표시할 지도
                position: latlng, // 마커를 표시할 위치
                title: title, // 마커의 타이틀, 마커에 마우스를 올리면 타이틀이 표시됩니다
                image: markerImage, // 마커 이미지
                clickable: true, // 마커를 클릭했을 때 지도의 클릭 이벤트가 발생하지 않도록 설정합니다
            })

            ary.push(marker)
            setMarkersItems([...ary])

            /**
             * 마커 클릭시, 좌측 하단에 스테이션명, 스테이션 주소를 게시하는 돔 생성하는 콜백함수
             */
            const searchDetailAddrFromCoords = async () => {
                marker.setImage(clickedMarker)
                setSelMarker(marker)
                setSelectMarkerInfo(data[i])
            }
            kakao.maps.event.addListener(marker, 'click', searchDetailAddrFromCoords)
        }
        //#endregion
    }

    //map 위치 이동 시
    const moveMap = () => {
        if (kakao && !isEmpty(kakao.maps)) {
            let places = new kakao.maps.services.Places()
            let _cityOne =
                selectSido?.SIDO_FULL_NAME === '전체' || isEmpty(selectSido) ? '' : selectSido?.SIDO_FULL_NAME
            let _cityTwo = selectGugun?.GUGUN === '전체' || isEmpty(selectGugun) ? '' : selectGugun?.GUGUN
            let keyword = _cityOne + _cityTwo

            if (!isEmpty(_cityOne)) {
                places.keywordSearch(keyword, function (result, status) {
                    if (status === kakao.maps.services.Status.OK && result.length > 0) {
                        let firstPlace = result[0]
                        let lat = firstPlace.y
                        let lng = firstPlace.x
                        let moveLatLon = new kakao.maps.LatLng(lat, lng)

                        map.setCenter(moveLatLon)
                        map.setLevel(9)
                    }
                })
            } else {
                if (isEmpty(map)) return
                let moveLatLon = new kakao.maps.LatLng(36.5, 127.7)

                map.setCenter(moveLatLon)
                map.setLevel(13)
            }
        }
    }

    //상세이미지 에러일때
    const handleImgError = e => {
        e.target.src = NO_IMAGE
    }

    return (
        <div className={isNewPage ? 'map-wrap nomargin new-map-wrap' : 'map-wrap'}>
            {/* 새창으로 띄웠을때만 보여줌 */}
            {isNewPage && (
                <div className="map-header">
                    <p className="map-title">
                        {selectSearchType === '05'
                            ? '배터리 교환 스테이션 검색'
                            : selectSearchType === '03'
                            ? '서비스 네트워크 검색'
                            : ''}
                    </p>
                    <div className="map-button-wrap">
                        <p>
                            {selectSearchType === '05'
                                ? '가까운 스테이션 위치를 확인해 보세요.'
                                : selectSearchType === '03'
                                ? '가까운 서비스 네트워크 위치를 확인해 보세요.'
                                : ''}
                        </p>
                        {/* 시도 버튼 */}
                        <button
                            onClick={e => {
                                setIsSelectSido(!isSelectSido)
                                const ref = sidoTextRef.current.getBoundingClientRect()
                                setSidoboxPosition({
                                    X: ref.left,
                                    Y: ref.top,
                                })
                            }}
                            ref={sidoTextRef}>
                            {selectSido?.SIDO_FULL_NAME}
                        </button>

                        {Object.keys(selectGugun).length !== 0 && (
                            <img className="localInfo-allow-img" src={ALLOW_RIGHT} alt="오른쪽 화살표"></img>
                        )}
                        {/* 구군 버튼 */}
                        {selectGugun.GUGUN && (
                            <button
                                onClick={() => {
                                    setIsSelectGugun(!isSelectGugun)
                                    const ref = gugunTextRef.current.getBoundingClientRect()
                                    setGugunboxPosition({
                                        X: ref.left,
                                        Y: ref.top,
                                    })
                                }}
                                ref={gugunTextRef}>
                                {selectGugun?.GUGUN}
                            </button>
                        )}
                    </div>
                </div>
            )}

            <div className="localInfo-wrap">
                {!isNewPage && (
                    <div className="localInfo-selectInfo-wrapper">
                        <span className="localInfo-selectInfo-wrap">
                            <span
                                className="localInfo-sido-text"
                                onClick={() => setIsSelectSido(!isSelectSido)}
                                ref={sidoTextRef}>
                                {selectSido?.SIDO_FULL_NAME}
                            </span>
                            {Object.keys(selectGugun).length !== 0 && (
                                <img className="localInfo-allow-img" src={ALLOW_RIGHT} alt="오른쪽 화살표"></img>
                            )}
                            <span
                                className="localInfo-gogun-text"
                                onClick={() => setIsSelectGugun(!isSelectGugun)}
                                ref={gugunTextRef}>
                                {selectGugun?.GUGUN}
                            </span>
                        </span>
                    </div>
                )}

                <div
                    className={isNewPage ? 'localInfo-select-wrapper-new' : 'localInfo-select-wrapper'}
                    ref={localInfoSelectWrapper}>
                    {isSelectSido && (
                        <div
                            className={isNewPage ? 'localInfo-select-sido-box position' : 'localInfo-select-sido-box'}
                            ref={sidoSelectBoxRef}
                            style={{
                                '--position-right': `${sidoboxPosition.X - 17}px`,
                                '--position-top': `${sidoboxPosition.Y + 5}px`,
                            }}>
                            <ul>
                                {sidoData.map((val, i) => (
                                    <li>
                                        <span
                                            onClick={() => {
                                                setIsSelectSido(false)
                                                setSelectSido(val)
                                            }}>
                                            {val?.SIDO_FULL_NAME}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                    {isSelectGugun && (
                        <div
                            className={isNewPage ? 'localInfo-select-gugun-box position' : 'localInfo-select-gugun-box'}
                            style={{
                                '--position-right': `${gugunboxPosition.X - 17}px`,
                                '--position-top': `${gugunboxPosition.Y + 5}px`,
                            }}>
                            <ul>
                                {gugunData.map((val, i) => (
                                    <li>
                                        <span
                                            onClick={() => {
                                                setIsSelectGugun(false)
                                                setSelectGugun(val)
                                            }}>
                                            {val?.GUGUN}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            </div>

            {/* 새창으로 띄운 페이지가 아날때만 버튼 보임 */}
            {!isNewPage && (
                <button className="map_open_button">
                    <a
                        href={selectSearchType === '05' ? `${URL.NETWORK.MAP}` : `${URL.NETWORK.SERVICE_MAP}`}
                        target="_blank">
                        새창으로 열기
                    </a>
                </button>
            )}

            {
                <div
                    className={
                        'localInfo-detail-wrap ' +
                        (isEmpty(selectMarkerInfo) ? 'visibility-hidden' : 'visibility-visible')
                    }>
                    {selectSearchType === '05' && (
                        <div className="localInfo-detail-image-wrap">
                            <img src={selectMarkerInfo?.Store_Img_Url} alt="스테이션 이미지" onError={handleImgError} />
                        </div>
                    )}
                    <div>
                        <div className="localInfo-detail-title-wrap">
                            <img src={MARKER_ICON} alt="마커이미지" />
                            <div>
                                <span>
                                    {selectSearchType === '03' && selectMarkerInfo?.Name}
                                    {selectSearchType === '05' && selectMarkerInfo?.Station_Name}
                                </span>
                                {selectSearchType === '05' && (
                                    <span className="localInfo-detail-title-state">{`(${selectMarkerInfo?.Station_State_Text})`}</span>
                                )}
                            </div>
                        </div>
                        {selectSearchType === '03' && (
                            <p className="localInfo-detail-address">{selectMarkerInfo?.Address}</p>
                        )}
                        {selectSearchType === '05' && (
                            <p className="localInfo-detail-address">{selectMarkerInfo?.Station_Total_Address}</p>
                        )}
                        <p className="localInfo-detail-address-detail">
                            {selectSearchType === '03' && selectMarkerInfo?.Zipcode
                                ? `(${selectMarkerInfo?.Zipcode})`
                                : ''}
                            {selectSearchType === '05' && selectMarkerInfo?.Station_ZipCode
                                ? `(${selectMarkerInfo?.Station_ZipCode})`
                                : ''}
                        </p>
                        <p className="localInfo-detail-tel">
                            {selectSearchType === '03' && (
                                <a href={`tel:${selectMarkerInfo?.Tel_No}`}>{selectMarkerInfo?.Tel_No}</a>
                            )}
                            {selectSearchType === '05' && (
                                <a href={`tel:${selectMarkerInfo?.Station_Tel}`}>{selectMarkerInfo?.Station_Tel}</a>
                            )}
                        </p>
                    </div>
                </div>
            }
            <div>
                <div id="service-map" className={isNewPage ? 'pull_size' : ''}></div>
            </div>
        </div>
    )
}

export default Map
